import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useToast } from '@/hooks'
import { type Member, useMembersMutations } from '@/modules/account'
import { useUser } from '@/modules/auth'
import { useDialogActions, useDialogData, useDialogIsOpen } from '@/stores'

const dialogId = 'remove-member'

export const RemoveMemberDialog = () => {
  const { successToast, errorToast } = useToast()
  const open = useDialogIsOpen(dialogId)
  const member = useDialogData() as Member
  const user = useUser()
  const isCurrentUser = user?.email === member?.email
  const { closeDialog } = useDialogActions()

  const { removeMember } = useMembersMutations()

  const handleSubmit = () => {
    removeMember(member)
      .then(() => {
        successToast('Member removed')
        if (isCurrentUser) window.location.reload()
      })
      .catch((error) => errorToast('Failed to remove member', error))
    closeDialog(true)
  }

  return (
    <Dialog open={open} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {isCurrentUser ? 'Leave account' : 'Remove member'}
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to{' '}
            {isCurrentUser ? (
              'leave'
            ) : (
              <>
                remove <strong>{member?.email}</strong>
              </>
            )}{' '}
            from your account? {isCurrentUser ? 'You' : 'They'} will lose access
            immediately.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-4">
          <Button theme="outline" onClick={() => closeDialog()}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} theme="danger">
            {isCurrentUser ? 'Leave' : 'Remove'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

RemoveMemberDialog.id = dialogId
